export default "__VITE_ASSET__8aqvjYdm__"